import { render, staticRenderFns } from "./BCXMessengerLoadingSkeleton.vue?vue&type=template&id=0937b765&scoped=true"
import script from "./BCXMessengerLoadingSkeleton.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerLoadingSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerLoadingSkeleton.vue?vue&type=style&index=0&id=0937b765&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0937b765",
  null
  
)

export default component.exports